import React, { memo, useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import styles from './ScrollTop.module.less';
import { scrollingDom } from '../../utils/utils';

export default memo(() => {
  // const [contentElement, setContentElement] = useState(null);
  const [visible, setVisible] = useState(false);

  const handleScroll = () => {
    const contentElement = document.getElementById('container_content');
    if (contentElement && contentElement.scrollTop > 1500) {
      setVisible(true);
      return;
    }
    setVisible(false);
  };

  const handleScrollToTop = () => {
    let speed = 80;
    const contentElement = document.getElementById('container_content');
    if (contentElement && contentElement.scrollTop > 0) {
      if (contentElement.scrollTop > 1000) {
        speed = parseInt(contentElement.scrollTop / 1000) * 50;
      }
      scrollingDom(contentElement, 0, speed);
    }
  };

  // useEffect(() => {
  //   setContentElement(document.getElementById('container_content'));
  // }, [document.getElementById('container_content')]);

  useEffect(() => {
    const contentElement = document.getElementById('container_content');
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    contentElement && contentElement.addEventListener('scroll', handleScroll);
    return () => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      contentElement && contentElement.removeEventListener('scroll', handleScroll);
    };
  }, []);
  if (!visible) {
    return <></>;
  }
  return (
    <div className={styles.scroll_top} onClick={handleScrollToTop}>
      {/* <i
        className={classNames('icon iconfont icon-arrow_up', styles.scrollIcon)}
        style={{ color: '#fff' }}
      /> */}
    </div>
  );
});
